import { CONTRACTS, DAT_NET_ABI } from '../config';

export default class DatumNetworkContract {
  public readonly instance: any;

  constructor(web3: any, isMainnet?: boolean) {
    if (!this.instance) {
      const address = isMainnet ? CONTRACTS.datum.MAINNET_ADDRESS : CONTRACTS.datum.TESTNET_ADDRESS;
      const Contract = web3.eth.contract(DAT_NET_ABI);
      this.instance = Contract.at(address);
    }
  }

  public withdrawTx(address: string, value: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.instance.withdrawal(address, { value }, (err: any, res: any) => {
        if (err) {
          return reject(err);
        }
        return resolve(res);
      });
    });
  }

  public balanceOf(address: string, web3: any) {
    return new Promise<any>((resolve, reject) => {
      web3.eth.getBalance(address, (err: any, balance: number) => {
        if (err) {
          return reject(err);
        }
        return resolve(Math.round(web3.fromWei(balance, 'ether') * 100) / 100);
      });
    });
  }
}
